import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from "react-router-dom";
import { Helpers } from '../../../helpers/Helpers';
import { MenuComponent } from '../../../_metronic/assets/ts/components';
import { KTCard } from '../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../_metronic/helpers/components/KTCardBody';
import Content from '../../../_metronic/layout/components/content/Content';
import { PageTitle } from '../../../_metronic/layout/core';
import toast from "react-hot-toast";
import { storeActivityIndicator } from '../../../redux/reducers/authSlice';
import { RootState } from '../../../redux/store';
import TableFooter from '../../../components/TableFooter';
import { ColumnChooserModel } from '../../../models/common/ColumnChooserModel';
import { kolonlariBirlestir } from '../../../components/ColumnFilter/kolonBirlestir';
import { buildExcelRequest, ExcelExportMode } from '../../../helpers/excelExportRequest';
import { ToolbarWrapper } from '../../../_metronic/layout/components/toolbar';
import RefreshButton from '../../../components/RefreshButton';
import ColumnChooser from '../../../components/ColumnChooser';
import ExcelExportMenu from '../../../components/ExcelExportMenu';
import CustomDatePicker from '../../../components/CustomDatePicker';
import Box from '../../../components/Box';
import { useSortableColumns } from '../../../helpers/useSortableColumns';
import ColumnFilterRow from '../../../components/ColumnFilter/ColumnFilterRow';
import ColumnFilterChips from '../../../components/ColumnFilter/ColumnFilterChips';
import { ColumnFilterDefinitions } from '../../../components/ColumnFilter/ColumnFilterTypes';
import { YES_NO_FILTER } from '../../../components/ColumnFilter/columnFilterOptions';
import { ColumnFilterModel } from '../../../models/common/ColumnFilterModel';
import { DURUM_SEKMELERI, durumRengi, ilkMutabakatListIstegi, MUTABAKAT_AYAR_SAYFASI, MUTABAKAT_SAYFASI, MutabakatListIstegi, MutabakatSatiri, MutabakatSayilari, tl, YurticiMutabakatService } from '../../../services/YurticiMutabakatService';
import DetayModal from './Components/DetayModal';
import IncelemeModal from './Components/IncelemeModal';

const SAYI_KOLONLARI = ['raporTutari', 'keylogxTutari', 'webServisTutari', 'fark'];

const INCELENDI_SECENEKLERI: { value: boolean | undefined, label: string }[] = [
    { value: false, label: 'İncelenmedi' },
    { value: true, label: 'İncelendi' },
    { value: undefined, label: 'Tümü' },
];

/**
 * Kargo Modülü > Yurtiçi Kargo > Gider Mutabakatı (24.10.2026, #485): Yurtiçi faturasındaki gönderi tutarı (İrsaliye
 * Matrahı, KDV hariç) ile siparişin beklenen gideri. Açılışta "Tutar farklı" sekmesi, son 30 gün, incelenmeyenler.
 * Dashboard kartından gelinirse o sekme açılır. Sipariş ve fatura değiştirmez; yalnız "İncelendi" işareti konur.
 */
const YurticiMutabakatList = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth)
    const pageName = MUTABAKAT_SAYFASI
    const pageVersion = "1";
    const gelenDurum = (location.state as any)?.durum as number | undefined;
    const [data, setData] = useState<{ list: MutabakatSatiri[], totalRecordCount: number }>({ list: [], totalRecordCount: 0 });
    const [sayilar, setSayilar] = useState<MutabakatSayilari | undefined>(undefined);
    const [filter, setFilter] = useState<MutabakatListIstegi>(() => {
        const ilk = ilkMutabakatListIstegi();
        return (location.state as any)?.durum !== undefined ? { ...ilk, durum: gelenDurum } : ilk;
    })
    const [acikSatir, setAcikSatir] = useState<string | undefined>(undefined);
    const [incelemeAcik, setIncelemeAcik] = useState<boolean>(false);
    const guncelleyebilir = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == pageName)?.canUpdate;
    const ayarYetkisi = !!auth.user.user?.data.authorizedMenus.find(x => x.menuName == MUTABAKAT_AYAR_SAYFASI);

    const getColumns = () => {
        var str = localStorage.getItem(pageName + "-" + pageVersion + "-filters");

        var list: ColumnChooserModel[] = [
            { title: 'Gönderi Kodu', name: 'gonderiKodu', order: 0, isVisible: true },
            { title: 'Sipariş Ref No', name: 'siparisRefNo', order: 0, isVisible: true },
            { title: 'Müşteri', name: 'musteriAdi', order: 0, isVisible: true },
            { title: 'Gönderi Tarihi', name: 'gonderiTarihiStr', order: 0, isVisible: true },
            { title: 'Fatura No', name: 'faturaNo', order: 0, isVisible: true },
            { title: 'Fatura Tarihi', name: 'faturaTarihiStr', order: 0, isVisible: true },
            { title: 'Rapor Tutarı (KDV hariç)', name: 'raporTutari', order: 0, isVisible: true },
            { title: 'Keylogx Beklenen Gider (KDV hariç)', name: 'keylogxTutari', order: 0, isVisible: true },
            { title: 'Web Servis Tutarı', name: 'webServisTutari', order: 0, isVisible: true },
            { title: 'Fark', name: 'fark', order: 0, isVisible: true },
            { title: 'Durum', name: 'durumAdi', order: 0, isVisible: true },
            { title: 'İncelendi', name: 'incelendiAdi', order: 0, isVisible: true },
            { title: 'Fatura Tipi', name: 'faturaTipi', order: 0, isVisible: false },
            { title: 'Kaynak', name: 'kaynakAdi', order: 0, isVisible: false },
            { title: 'İnceleme Notu', name: 'incelemeNotu', order: 0, isVisible: false }
        ];

        for (var i = 0; i < list.length; i++)
            list[i].order = i + 1;

        return kolonlariBirlestir(list, str);
    }

    const [columns, setColumns] = useState<ColumnChooserModel[]>(getColumns());

    const performPagination = (i: number) => getData({ ...filter, currentPage: i, skip: (i - 1) * filter.take });

    const changeTake = (_take: number) => getData({ ...filter, currentPage: 1, skip: 0, take: _take });

    useEffect(() => {
        setTimeout(() => { MenuComponent.reinitialization() }, 1000)

        getData();
    }, [])

    // Kolon filtresinde art arda istek gidebilir; yalnızca en son isteğin cevabı ekrana yazılır.
    const lastRequestNo = useRef(0);

    const getData = async (_filter: MutabakatListIstegi | undefined = undefined) => {
        const requestNo = ++lastRequestNo.current;

        try {
            if (_filter)
                setFilter(_filter);
            else
                _filter = filter;

            dispatch(storeActivityIndicator(true))

            var [response, sayiCevabi] = await Promise.all([YurticiMutabakatService.getList(_filter), YurticiMutabakatService.sayilar(_filter)]);

            if (requestNo != lastRequestNo.current)
                return;

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            setData(response.data ?? { list: [], totalRecordCount: 0 });
            setSayilar(sayiCevabi.isSuccess ? sayiCevabi.data : undefined);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            if (requestNo == lastRequestNo.current)
                dispatch(storeActivityIndicator(false))
        }
    }

    const setItemSelected = (_id: string) => {
        setData({
            ...data,
            list: data.list.map(function (x) {
                if (x.yurticiMutabakatSatiriId == _id)
                    x.isSelected = !x.isSelected;
                return x;
            })
        })
    }

    const selectAll = () => {
        var isAllSelected = data.list.length == data.list.filter(x => x.isSelected).length;

        setData({
            ...data,
            list: data.list.map(function (x) {
                x.isSelected = !isAllSelected;
                return x;
            })
        })
    }

    const excelExport = async (mode: ExcelExportMode) => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YurticiMutabakatService.exportList({ ...buildExcelRequest(filter, mode, data.list.filter(x => x.isSelected).map(x => x.yurticiMutabakatSatiriId), columns) });

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            window.location.href = Helpers.getEndpoint() + "/Excels/" + response.data;
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    // Kolon adları backend'deki eşlemeyle (YurticiMutabakatListe) aynı.
    const sortableColumns = ['gonderiKodu', 'siparisRefNo', 'musteriAdi', 'gonderiTarihiStr', 'faturaNo', 'faturaTarihiStr', 'raporTutari', 'keylogxTutari', 'webServisTutari', 'fark', 'durumAdi', 'incelendiAdi'];

    const { thProps, sortArrow } = useSortableColumns(sortableColumns, filter, getData);

    const columnFilterDefinitions: ColumnFilterDefinitions = {
        gonderiKodu: { type: 'text' },
        siparisRefNo: { type: 'text' },
        musteriAdi: { type: 'text' },
        gonderiTarihiStr: { type: 'date' },
        faturaNo: { type: 'text' },
        faturaTarihiStr: { type: 'date' },
        faturaTipi: { type: 'text' },
        raporTutari: { type: 'number' },
        keylogxTutari: { type: 'number' },
        webServisTutari: { type: 'number' },
        fark: { type: 'number' },
        durumAdi: { type: 'text' },
        kaynakAdi: { type: 'text' },
        incelendiAdi: YES_NO_FILTER,
        incelemeNotu: { type: 'text' },
    };

    const changeColumnFilters = (columnFilters: ColumnFilterModel[]) => {
        getData({ ...filter, columnFilters: columnFilters, currentPage: 1, skip: 0 });
    }

    const getColumnValue = (item: MutabakatSatiri, column: string, className: string | undefined) => {
        var item2: any = item;
        var deger: any = item2[column];
        var stil: React.CSSProperties | undefined = SAYI_KOLONLARI.includes(column) ? { textAlign: 'right', whiteSpace: 'nowrap' } : undefined;

        if (column == 'durumAdi')
            deger = <span className={`badge badge-light-${durumRengi(item.durum)}`}>{item.durumAdi}</span>;
        else if (column == 'fark')
            deger = item.fark == null ? '—' : <span className={item.fark > 0 ? 'text-danger fw-bolder' : item.fark < 0 ? 'text-success fw-bolder' : 'text-gray-500'}>{tl(item.fark)}</span>;
        else if (SAYI_KOLONLARI.includes(column))
            deger = tl(deger);
        else if (column == 'siparisRefNo' && item.yurticiCargoId)
            deger = <a className='cursor-pointer' onClick={(e) => { e.stopPropagation(); navigate('/yurticicargo/listadd?id=' + item.yurticiCargoId); }}>{item.siparisRefNo}</a>;
        else if (column == 'siparisRefNo')
            deger = '—';
        else if (column == 'incelendiAdi')
            deger = item.incelendi ? <span className='badge badge-light-success' title={item.incelemeNotu}>Evet</span> : 'Hayır';

        return <td className={className} style={{ ...stil, cursor: 'pointer' }} onClick={() => setItemSelected(item.yurticiMutabakatSatiriId)} onDoubleClick={() => setAcikSatir(item.yurticiMutabakatSatiriId)}>{deger}</td>;
    }

    const simdiCalistir = async () => {
        try {
            dispatch(storeActivityIndicator(true))

            var response = await YurticiMutabakatService.simdiCalistir();

            if (!response.isSuccess) {
                toast.error(response.message)
                return;
            }

            toast.success('Mutabakat çalıştırıldı. Sonuç Çalışma Geçmişi\'nde.')
            getData();
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    const seciliIdler = data.list.filter(x => x.isSelected).map(x => x.yurticiMutabakatSatiriId);

    return (
        <React.Fragment>
            <ToolbarWrapper filters={<React.Fragment>
                <RefreshButton onClick={() => getData()} />

                <Box width='150px'>
                    <CustomDatePicker value={filter.baslangicTarihi} setValue={(v: string | undefined) => getData({ ...filter, baslangicTarihi: v, currentPage: 1, skip: 0 })} />
                </Box>
                <Box className='text-gray-500'>—</Box>
                <Box width='150px'>
                    <CustomDatePicker value={filter.bitisTarihi} setValue={(v: string | undefined) => getData({ ...filter, bitisTarihi: v, currentPage: 1, skip: 0 })} />
                </Box>

                <select
                    id='mutabakat-incelendi'
                    className='form-select form-select-sm w-auto'
                    value={filter.incelendi === undefined ? '' : String(filter.incelendi)}
                    onChange={e => getData({ ...filter, incelendi: e.target.value == '' ? undefined : e.target.value == 'true', currentPage: 1, skip: 0 })}
                >
                    {INCELENDI_SECENEKLERI.map(x => <option key={String(x.value)} value={x.value === undefined ? '' : String(x.value)}>{x.label}</option>)}
                </select>

                <div style={{ flex: 1 }}></div>

                {
                    guncelleyebilir && (
                        <button disabled={seciliIdler.length == 0} onClick={() => setIncelemeAcik(true)} className='btn btn-sm btn-flex btn-light-success'>
                            <i className='fa fa-check fs-6 me-1' />
                            İncelendi işaretle
                        </button>
                    )
                }

                <ColumnChooser columns={columns} getColumns={getColumns} pageName={pageName} pageVersion={pageVersion} setColumns={setColumns} />

                <ExcelExportMenu pageName={pageName} selectedCount={seciliIdler.length} onExport={excelExport} />

                <div className='m-0'>
                    <a onClick={() => navigate('/yurticimutabakat/gecmis')} className='btn btn-sm fw-bold btn-light-primary'>Çalışma Geçmişi</a>
                </div>

                {
                    ayarYetkisi && (
                        <div className='m-0'>
                            <a onClick={() => navigate('/yurticimutabakat/ayar')} className='btn btn-sm fw-bold btn-light'><i className='fa fa-gear me-1' />Ayarlar</a>
                        </div>
                    )
                }

                {
                    guncelleyebilir && (
                        <div className='m-0'>
                            <a onClick={simdiCalistir} className='btn btn-sm fw-bold btn-primary'>Şimdi çalıştır</a>
                        </div>
                    )
                }
            </React.Fragment>} />

            <PageTitle breadcrumbs={[{
                title: pageName.split('>').slice(0, pageName.split('>').length - 1).join(' > ') + ' > ',
                isActive: false,
                path: ''
            }]}>{(pageName.split('>')[pageName.split('>').length - 1])}</PageTitle>

            <Content>
                <KTCard className='mb-3'>
                    <KTCardBody className='py-2'>
                        {/* Durum sekmeleri: adetler aynı tarih / inceleme filtresiyle */}
                        <div className='d-flex flex-wrap gap-2 mb-3'>
                            {
                                DURUM_SEKMELERI.map(s => {
                                    const adet = s.value === undefined ? sayilar?.toplam : (sayilar?.durumlar?.[s.value] ?? 0);
                                    const secili = filter.durum === s.value;
                                    return (
                                        <a
                                            key={String(s.value)}
                                            onClick={() => getData({ ...filter, durum: s.value, currentPage: 1, skip: 0 })}
                                            className={'btn btn-sm ' + (secili ? 'btn-' + s.renk : 'btn-light-' + s.renk)}
                                        >
                                            {s.label} <span className={'badge ms-1 ' + (secili ? 'badge-light' : 'badge-' + s.renk)}>{adet ?? '…'}</span>
                                        </a>
                                    )
                                })
                            }
                        </div>

                        <ColumnFilterChips
                            columns={columns}
                            definitions={columnFilterDefinitions}
                            filters={filter.columnFilters}
                            onChange={changeColumnFilters}
                        />

                        <div className='table-responsive new-table-container'>
                            <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer ebbe-compact-table'>
                                <thead>
                                    <tr className='text-start text-muted fw-bolder text-uppercase'>
                                        <th style={{ width: 1 }}>
                                            <div className='d-flex'>
                                                <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                    <input onChange={selectAll} className='form-check-input' type='checkbox' checked={data.list.length > 0 && data.list.filter(x => x.isSelected).length == data.list.length} />
                                                </label>
                                            </div>
                                        </th>

                                        {
                                            columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; }).map((item) =>
                                                <th {...thProps(item.name)}>
                                                    {item.title}
                                                    {sortArrow(item.name)}
                                                </th>
                                            )
                                        }
                                    </tr>

                                    <ColumnFilterRow
                                        columns={columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order; })}
                                        definitions={columnFilterDefinitions}
                                        filters={filter.columnFilters}
                                        onChange={changeColumnFilters}
                                        leadingCellCount={1}
                                    />
                                </thead>
                                <tbody className='text-gray-600 fw-bold'>
                                    {
                                        data.list.length == 0 && (
                                            <tr>
                                                <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                            </tr>
                                        )
                                    }
                                    {
                                        data.list.map((item) =>
                                            <tr key={item.yurticiMutabakatSatiriId} style={{ background: item.isSelected ? 'rgba(204, 204, 204, 0.25)' : undefined }}>
                                                <td style={{ width: 1 }}>
                                                    <div className='d-flex'>
                                                        <label className='form-check form-check-sm form-check-custom form-check-solid me-5'>
                                                            <input onChange={() => setItemSelected(item.yurticiMutabakatSatiriId)} className='form-check-input' type='checkbox' checked={!!item.isSelected} />
                                                        </label>
                                                    </div>
                                                </td>

                                                {
                                                    columns.filter(x => x.isVisible).sort(function (a, b) { return a.order - b.order }).map((column) => (
                                                        <React.Fragment key={column.name}>{getColumnValue(item, column.name, column.className)}</React.Fragment>
                                                    ))
                                                }
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>

                        {/* Seçili sekmenin toplamları */}
                        {
                            sayilar && (
                                <div className='d-flex flex-wrap gap-6 justify-content-end py-3 fs-7 fw-bold'>
                                    <span>{sayilar.kayitSayisi.toLocaleString('tr-TR')} kayıt</span>
                                    <span>Toplam artı fark: <span className='text-danger'>{tl(sayilar.artiFark)}</span></span>
                                    <span>Toplam eksi fark: <span className='text-success'>{tl(sayilar.eksiFark)}</span></span>
                                </div>
                            )
                        }
                        <div className='text-muted fs-8 pb-2'>
                            Fark = Yurtiçi tutarı − Keylogx beklenen gideri (KDV hariç). Artı (kırmızı): Yurtiçi beklenenden pahalı; eksi (yeşil): ucuz.
                            Satıra çift tıklayınca ayrıntı açılır.
                        </div>
                    </KTCardBody>

                    <TableFooter
                        changeTake={changeTake}
                        take={filter.take}
                        currentPage={filter.currentPage}
                        performPagination={performPagination}
                        totalPageCount={Math.ceil(data.totalRecordCount / filter.take)}
                        totalRecordCount={data.totalRecordCount}
                        selectedCount={seciliIdler.length}
                    />
                </KTCard>
            </Content>

            <DetayModal satirId={acikSatir} onClose={() => setAcikSatir(undefined)} />

            <IncelemeModal
                ids={seciliIdler}
                show={incelemeAcik}
                onClose={() => setIncelemeAcik(false)}
                onKaydedildi={() => { setIncelemeAcik(false); getData(); }}
            />
        </React.Fragment>
    )
}

export default YurticiMutabakatList;
